import { extend } from 'vee-validate';
// eslint-disable-next-line camelcase
import { required, numeric, min_value } from 'vee-validate/dist/rules';
// @ts-ignore
import { messages } from 'vee-validate/dist/locale/en.json';

extend('required', { ...required, message: messages['required'] });
extend('numeric', { ...numeric, message: messages['numeric'] });
// eslint-disable-next-line camelcase
extend('min_value', { ...min_value, message: messages['min_value'] });
